import type { MigrationStrategies } from "./_types/migration-strategies";

export const NON_PHARMA_ITEM_MIGRATION_STRATEGIES: MigrationStrategies = {
  // v0 -> v1: `brand` and `snomedId` widened from `string` to
  // `["string", "null"]`. Stored docs already conform; no transform.
  1: (oldDoc) => oldDoc,
};
